var _rect, _g, _rect2, _g2, _g3, _g4, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicFingerprintIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 148,
    viewBox: "0 0 185 148",
    fill: "none",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 34.7402,
    width: 176,
    height: 112.719,
    rx: 11.76,
    fill: "url(#paint0_linear_301_7523)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_301_7523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8203,
    y: 50.582,
    width: 144.36,
    height: 21.7528,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 23,
    y: 58.7402,
    width: 40,
    height: 6,
    rx: 3,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_301_7523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.7402,
    width: 69.2135,
    height: 21.7528,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_301_7523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.9688,
    y: 80.2461,
    width: 69.2135,
    height: 21.7528,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_301_7523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8203,
    y: 109.908,
    width: 144.36,
    height: 21.7528,
    rx: 8,
    fill: "#3866C2",
    fillOpacity: 0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 23,
    y: 88,
    width: 40,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 98,
    y: 88,
    width: 40,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 23,
    y: 118,
    width: 40,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 89,
    height: 84,
    rx: 16,
    fill: "url(#paint1_linear_301_7523)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.714 43.6587C128.389 47.1948 128.921 50.5961 129.794 53.1269C130.666 55.6578 131.891 57.3508 131.999 57.4996L132.001 57.5016C132.25 57.8381 132.658 57.9992 133.039 57.9992C133.249 57.9992 133.463 57.9513 133.657 57.852C134.255 57.5593 134.485 56.855 134.089 56.3035L134.076 56.2862C134.052 56.2539 133.004 54.7997 132.241 52.5988C131.471 50.3755 131.006 47.4323 132.133 44.4317C133.33 41.2121 136.289 38.8997 139.45 38.6543C141.884 38.4637 143.996 39.5144 145.411 41.7083C146.24 43.0053 146.37 44.4571 146.276 45.6254C146.182 46.7934 145.866 47.6404 145.848 47.6859C145.591 48.3374 146.061 48.9317 146.665 49.0926C146.982 49.1784 147.318 49.1358 147.595 49.0163C147.869 48.8981 148.136 48.6819 148.257 48.3692C148.599 47.4857 149.793 44.1538 147.552 40.6589C145.672 37.7388 142.565 36.1499 139.168 36.4203C135.004 36.7403 131.216 39.6411 129.714 43.6587Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.042 54.4822C144.488 54.4071 142.662 53.7194 141.532 52.5133C140.386 51.2827 140.059 49.6376 140.035 48.2495C140.024 47.5602 140.087 46.9485 140.155 46.5069C140.189 46.2864 140.223 46.1094 140.25 45.9877C140.263 45.9268 140.274 45.8802 140.281 45.8491L140.288 45.8229L140.295 45.7996C140.473 45.1325 139.954 44.5771 139.34 44.4641C138.737 44.3531 138.05 44.6538 137.879 45.281C137.836 45.4319 137.501 46.7296 137.547 48.4035C137.594 50.0941 138.032 52.2172 139.607 53.9118C141.255 55.6787 143.751 56.587 146.959 56.6797H147.005C147.608 56.6797 148.218 56.2702 148.247 55.6194C148.277 54.9405 147.658 54.5005 147.042 54.4822Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.582 51.9523C126.874 52.0838 127.199 52.0975 127.483 52.0496L127.489 52.0486C127.804 51.9906 128.095 51.8275 128.263 51.5245C128.425 51.2303 128.43 50.8767 128.334 50.5154C127.943 49.0264 127.821 47.4131 127.96 45.8279C128.551 38.9143 134.183 33.8595 140.314 34.202C146.41 34.5638 150.948 40.2652 150.354 47.2377L150.252 47.9817C149.862 49.4323 148.787 50.4616 147.308 50.4616C146.469 50.4616 145.695 50.2764 145.164 49.8417C144.628 49.4035 144.362 48.7392 144.362 48.0885V44.9798C144.362 42.6178 142.079 40.8142 139.427 40.8142C137.446 40.8142 135.633 41.7885 134.862 43.38C134.126 44.891 133.123 47.5758 133.521 50.5719C133.922 53.5956 135.741 56.8632 140.512 59.5287C141.008 59.8168 141.811 59.836 142.26 59.2715C142.466 59.0165 142.55 58.6777 142.462 58.3392C142.373 58.0006 142.125 57.7091 141.756 57.5029C137.827 55.3064 136.308 52.7966 135.923 50.487C135.535 48.1531 136.288 45.938 137.075 44.3188C137.329 43.796 137.655 43.4805 138.03 43.289C138.413 43.0934 138.877 43.0118 139.427 43.0118C140.854 43.0118 141.876 43.9601 141.876 44.9798V48.0885C141.876 48.7475 142.12 49.4382 142.474 50.0536C142.83 50.6725 143.316 51.2461 143.84 51.6729C145.27 52.8377 147.31 53.0161 149.061 52.3902C150.823 51.7605 152.35 50.2976 152.726 48.1145L152.817 47.328L152.818 47.316C153.511 39.2369 147.51 32.2827 139.984 31.8354C132.448 31.3794 126.151 37.8001 125.463 45.8343C125.307 47.6487 125.477 49.4622 125.926 51.168C126.028 51.5548 126.276 51.8145 126.582 51.9523Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.202 34.8887C152.797 32.6065 150.234 30.0416 145.598 28.6843C140.975 27.328 136.389 28.5989 132.95 30.2166C129.524 31.8283 127.174 33.8127 126.956 34.018C126.513 34.4269 126.382 35.258 126.991 35.7047C127.518 36.0977 128.28 36.0146 128.827 35.5104C128.827 35.5104 128.835 35.5038 128.851 35.4888C128.868 35.4745 128.891 35.4537 128.922 35.4271C128.983 35.3739 129.073 35.2974 129.19 35.2014C129.423 35.0096 129.762 34.7404 130.191 34.426C131.052 33.7966 132.272 32.9881 133.732 32.2535C136.663 30.7793 140.499 29.6321 144.315 30.7469C152.174 33.0517 153.37 39.3898 153.417 39.6473C153.52 40.2465 154.105 40.572 154.646 40.572L154.652 40.572C154.69 40.572 154.757 40.5721 154.829 40.561C155.435 40.4828 155.993 39.9726 155.874 39.2992L155.873 39.2929L155.872 39.284L155.867 39.2565L155.853 39.1658C155.84 39.0911 155.823 38.9907 155.798 38.8679C155.749 38.6222 155.672 38.2877 155.552 37.8878C155.313 37.0885 154.903 36.0262 154.202 34.8887Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.935 27.5499L134.943 27.5467C135.138 27.4597 137.787 26.3363 141.218 26.1865C144.641 26.0371 148.807 26.8555 152.12 30.6039L152.121 30.6055C152.377 30.8922 152.746 31.0255 153.102 31.0255C153.334 31.0255 153.584 30.9684 153.805 30.8359L153.811 30.8324C154.081 30.6646 154.27 30.407 154.325 30.1078C154.381 29.8051 154.293 29.4948 154.077 29.2496C150.131 24.7798 145.077 23.8561 141.032 24.0465C139.01 24.1417 137.231 24.5149 135.95 24.867C135.31 25.0432 134.792 25.2145 134.43 25.3437C134.249 25.4084 134.106 25.4626 134.007 25.5017C133.957 25.5213 133.918 25.5371 133.89 25.5485L133.856 25.5622L133.846 25.5664L133.843 25.5676L133.835 25.5714C133.246 25.83 132.926 26.5103 133.304 27.1022C133.638 27.6327 134.377 27.786 134.935 27.5499Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_301_7523",
    x: -3.12257,
    y: 31.6392,
    width: 182.245,
    height: 59.6386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_301_7523",
    x: -2.94288,
    y: 61.7974,
    width: 107.101,
    height: 59.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_301_7523",
    x: 72.0259,
    y: 61.3032,
    width: 107.101,
    height: 59.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_301_7523",
    x: -3.12257,
    y: 90.9653,
    width: 182.245,
    height: 59.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.47144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_7523",
    x1: 88,
    y1: 34.7402,
    x2: 88,
    y2: 147.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_7523",
    x1: 108.156,
    y1: 53.9437,
    x2: 175.085,
    y2: 35.4438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicFingerprintIllustration);
export default __webpack_public_path__ + "static/media/sonic-fingerprint-illustration.2100e48923cffe45906cb1410f412b9b.svg";
export { ForwardRef as ReactComponent };